import {bindTypesToActions} from '@src/utils/redux_utils';


const types={
    GetConfig:'CONFIG_GET',
    Success:'CONFIG_SUCCESS',
    Failed:'CONFIG_FAILED',
    Loaded:'CONFIG_LOADED'
}

const ConfigActions=bindTypesToActions(types);

const initialState={
    configuration:null,
    configLoaded:false
}

const ConfigReducer=(state=initialState,{type,payload})=>{
    switch(type){
        case types.Success:
           
            const configuration={...payload}

            return {
                configuration
            }
        case types.Loaded:
            return {
                ...state,configLoaded:true
            }    
        default: return state;    
    }
}

export {
    types as ConfigTypes,
    ConfigReducer,
    ConfigActions
}